import React, { useState } from 'react';

const Pricing = () => {
  const [selectedPlan, setSelectedPlan] = useState('emprendedor');
  const [billingCycle, setBillingCycle] = useState('mensual');

  const scrollToContact = () => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const plans = {
    emprendedor: {
      name: "Emprendedor",
      devPrice: "$ 100.000",
      monthly: 25000,
      description: "Tu primer estudio online: profesional, simple y funcionando en días, sin complicarte.",
      features: [
        "Diseñado para mostrarte confiable desde el primer día",
        "100% gestionado: vos solo te dedicás a tus clientes",
        "Hosting seguro y mantenimiento mensual incluido",
        "Formularios de contacto listos para convertir consultas",
        "Certificado SSL para máxima seguridad"
      ],
      cta: "Comenzar ahora"
    },
    pequenos: {
      name: "Teams",
      devPrice: "$ 200.000",
      monthly: 45000,
      description: "Ideal para estudios con hasta 5 socios",
      features: [
        "Todo lo del plan emprendedor",
        "Soporte prioritario 24/5",
        "Actualizaciones mensuales a demanda",
        "Integración WhatsApp"
      ],
      cta: "Contratar"
    },
    grandes: {
      name: "Grandes Estudios",
      devPrice: "ARS 500.000",
      monthly: 100000,
      description: "Solución completa para grandes estudios con amplia trayectoria y cantidad de clientes",
      features: [
        "Todo lo del plan Teams",
        "Páginas ilimitadas",
        "Soporte prioritario 24/7",
        "Actualizaciones diarias a demanda",
        "Integraciones personalizadas"
      ],
      cta: "Contratar"
    }
  };

  const calculateAnnualPrice = (monthlyPrice) => {
    return Math.round(monthlyPrice * 12 * 0.85);
  };

  return (
    <section className="py-16 bg-gray-50" id="precios">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Planes a Medida</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Soluciones digitales diseñadas específicamente para contadores
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="inline-flex rounded-md shadow-sm">
            <button
              onClick={() => setBillingCycle('mensual')}
              className={`px-4 py-2 text-sm font-medium rounded-l-lg ${billingCycle === 'mensual' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
            >
              Pago Mensual
            </button>
            <button
              onClick={() => setBillingCycle('anual')}
              className={`px-4 py-2 text-sm font-medium rounded-r-lg ${billingCycle === 'anual' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
            >
              Pago Anual (15% OFF)
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {Object.entries(plans).map(([key, plan]) => (
            <div
              key={key}
              onClick={() => setSelectedPlan(key)}
              className={`
                bg-white p-8 rounded-xl shadow-lg border-2
                cursor-pointer transform transition-all duration-300
                ${selectedPlan === key
                  ? 'scale-105 border-blue-600'
                  : 'scale-100 border-transparent hover:border-gray-200 hover:scale-105'}
              `}
            >
              <div className="mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <p className="text-gray-600 mb-4">{plan.description}</p>
                
                <div className="mb-4">
                  <span className="text-sm text-gray-500">Desarrollo:</span>
                  <div className="text-xl font-bold text-blue-600">{plan.devPrice}</div>
                </div>

                <div className="mb-6">
                  <span className="text-sm text-gray-500">Mantenimiento:</span>
                  {billingCycle === 'mensual' ? (
                    <div className="text-2xl font-bold text-gray-900">ARS {plan.monthly.toLocaleString('es-AR')}/mes</div>
                  ) : (
                    <>
                      <div className="text-2xl font-bold text-gray-900">ARS {calculateAnnualPrice(plan.monthly).toLocaleString('es-AR')}/año</div>
                      <div className="text-sm text-gray-500 line-through">ARS {(plan.monthly * 12).toLocaleString('es-AR')}</div>
                    </>
                  )}
                </div>

                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedPlan(key);
                  scrollToContact();
                }}
                className={`w-full py-3 px-6 rounded-lg font-medium transition-colors shadow-md
                  ${selectedPlan === key 
                    ? 'bg-blue-600 text-white hover:bg-blue-700' 
                    : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center text-gray-500">
          <p>Todos los planes incluyen dominio .com.ar por 1 año y certificado SSL</p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
